import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const links = [
  { to: "/", label: "首页" },
  { to: "/features", label: "阅读功能" },
  { to: "/comics", label: "漫画库" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const solid = scrolled || !isHome || open;

  return (
    <header
      className={`fixed top-0 left-0 z-50 w-full transition-colors duration-300 ${
        solid ? "bg-background-50/90 backdrop-blur border-b border-background-200/70" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[72px] w-full items-center justify-between px-4 md:px-8">
        <Link to="/" className="flex items-center gap-2">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-lg text-lg font-bold ${
              solid ? "bg-primary-500 text-background-50" : "bg-primary-500 text-background-50"
            }`}
          >
            <i className="ri-book-2-line" />
          </span>
          <span
            className={`font-heading text-xl tracking-wide ${
              solid ? "text-foreground-950" : "text-background-50"
            }`}
          >
            扑飞漫画网
          </span>
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={`text-sm font-medium transition-colors hover:text-primary-500 ${
                solid ? "text-foreground-800" : "text-background-100/90"
              } ${location.pathname === l.to ? "text-primary-500" : ""}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <Link
            to="/features"
            className={`whitespace-nowrap rounded-md px-4 py-2 text-sm font-semibold transition-colors ${
              solid
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-primary-500 text-background-50 hover:bg-primary-600"
            }`}
          >
            开始阅读
          </Link>
        </div>

        <button
          type="button"
          aria-label="切换菜单"
          onClick={() => setOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-md text-xl md:hidden ${
            solid ? "text-foreground-950" : "text-background-50"
          }`}
        >
          <i className={open ? "ri-close-line" : "ri-menu-line"} />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-4 md:hidden">
          <nav className="flex flex-col gap-1">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className={`rounded-md px-3 py-3 text-sm font-medium ${
                  location.pathname === l.to
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-800 hover:bg-background-100"
                }`}
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/features"
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-3 py-3 text-center text-sm font-semibold text-background-50"
            >
              开始阅读
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}